export const EVENT_CATEGORY_VALUES = Object.freeze([
  "tcg",
  "private_event",
  "birthday",
  "meeting",
  "culture_course",
  "other",
]);

export const EVENT_CATEGORY_PRESENTATION = Object.freeze({
  tcg: Object.freeze({
    value: "tcg",
    label: "TCG / Tournoi",
    color: "#8b5cf6",
    background: "rgba(139, 92, 246, 0.18)",
    border: "rgba(139, 92, 246, 0.72)",
  }),

  meeting: Object.freeze({
    value: "meeting",
    label: "Réunion",
    color: "#4f9cf9",
    background: "rgba(79, 156, 249, 0.18)",
    border: "rgba(79, 156, 249, 0.72)",
  }),

  birthday: Object.freeze({
    value: "birthday",
    label: "Anniversaire",
    color: "#f5b82e",
    background: "rgba(245, 184, 46, 0.18)",
    border: "rgba(245, 184, 46, 0.72)",
  }),

  private_event: Object.freeze({
    value: "private_event",
    label: "Événement privé",
    color: "#ff4fa3",
    background: "rgba(255, 79, 163, 0.18)",
    border: "rgba(255, 79, 163, 0.72)",
  }),

  culture_course: Object.freeze({
    value: "culture_course",
    label: "Culture / Cours",
    color: "#7fbd36",
    background: "rgba(127, 189, 54, 0.18)",
    border: "rgba(127, 189, 54, 0.72)",
  }),

  other: Object.freeze({
    value: "other",
    label: "Autre",
    color: "#8993a7",
    background: "rgba(137, 147, 167, 0.16)",
    border: "rgba(137, 147, 167, 0.60)",
  }),
});

export const DEFAULT_EVENT_CATEGORY = "other";

export function normalizeEventCategory(value) {
  return EVENT_CATEGORY_VALUES.includes(value)
    ? value
    : DEFAULT_EVENT_CATEGORY;
}

export function resolveEventCategoryPresentation(value) {
  return EVENT_CATEGORY_PRESENTATION[
    normalizeEventCategory(value)
  ];
}
